import React, { useEffect, useState } from "react";
import { InputNumber, Slider, Space, Row, Col } from "antd";

const NumberInput = ({ valueSpec, onChange }) => {
  const [sValue, setSValue] = useState(null);
  const [tValue, setTValue] = useState("");

  useEffect(() => {
    setSValue(Number(valueSpec.value));
    setTValue(Number(valueSpec.value));
    return () => {};
  }, [valueSpec]);

  const handleSliderChange = (v) => {
    setSValue(v);
    setTValue(v);
    onChange(v.toString());
  };

  const handleNumberInputChange = event => {
    if (event.target.value === "") {
      setSValue(0);
      setTValue("");
    } else {
      const newValue = Number(event.target.value);
      setSValue(newValue);
      setTValue(newValue);
      onChange(newValue.toString());
    }
  };

  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
      <Space direction="vertical" size="small" style={{ width: "100%" }}>
        {valueSpec.name && (
          <div style={{ fontSize: "1rem", fontWeight: 600 }}>
            {valueSpec.name}
          </div>
        )}
        <Row gutter={8} align="middle">
          {valueSpec.min !== null && valueSpec.max != null && (
            <Col span={16}>
              <Slider
                value={sValue}
                onChange={handleSliderChange}
                min={valueSpec.min}
                max={valueSpec.max}
                tooltip={{ formatter: (value) => value }}
              />
            </Col>
          )}
          <Col span={valueSpec.min !== null && valueSpec.max != null ? 8 : 24}>
            <InputNumber
              value={tValue}
              onChange={value => {
                if (value === null || value === undefined) {
                  setSValue(0);
                  setTValue("");
                  onChange("0");
                } else {
                  setSValue(value);
                  setTValue(value);
                  onChange(value.toString());
                }
              }}
              min={valueSpec.min !== null ? valueSpec.min : undefined}
              max={valueSpec.max !== null ? valueSpec.max : undefined}
              style={{ width: "100%" }}
            />
          </Col>
        </Row>
      </Space>
    </div>
  );
};

export default NumberInput;
